export default {"src":"/_next/static/media/yahoo.2f86bc62.svg","height":108,"width":158,"blurWidth":0,"blurHeight":0};